import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import i18n from 'modules/core/lib/i18n'

import type { SearchPlugin, SearchPluginHook } from 'modules/command_bar/lib/types'
import { SPACES } from 'modules/documents/lib/constants'
import { Documents } from 'modules/documents/store/collections/documents'
import { Folders } from 'modules/documents/store/collections/folders'

import { useDocumentResults } from './_useDocumentResults'
import { useFolderResults } from './_useFolderResults'

const useDocumentsPlugins: SearchPluginHook = (search) => {
  const { employee } = useCurrentSession()
  const documentsCollection = useLazyRef(() => new Documents()).current
  const foldersCollection = useLazyRef(() => new Folders()).current

  const employeeId = employee?.id
  const documentResults = useDocumentResults({ search, documentsCollection, foldersCollection })
  const folderResults = useFolderResults({ search, foldersCollection })

  const { loading } = useAsyncData(() => {
    if (!employeeId) return Promise.resolve()

    const data = { space: SPACES.EMPLOYEE_MY_DOCUMENTS, employee_id: employeeId }

    return Promise.all([documentsCollection.fetch({ data }), foldersCollection.fetch({ data })])
  }, [employeeId])

  return {
    id: 'documents',
    title: i18n.t('command_bar.plugins.documents.title'),
    results: [...documentResults, ...folderResults],
    loading,
  }
}

export const documentsPlugins: SearchPlugin = {
  hook: useDocumentsPlugins,
}
